module.exports = ".btn-info {\r\n  color: #fff;\r\n  background-color: #0e7ebd;\r\n  border-color: #0e7ebd;\r\n}\r\n"